import { render, staticRenderFns } from "./ListBnAvoirFourVal.vue?vue&type=template&id=5a35b5dc&"
import script from "./ListBnAvoirFourVal.vue?vue&type=script&lang=js&"
export * from "./ListBnAvoirFourVal.vue?vue&type=script&lang=js&"
import style0 from "./ListBnAvoirFourVal.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports